import { render, staticRenderFns } from "./Pallet.vue?vue&type=template&id=29433860"
import script from "./Pallet.vue?vue&type=script&lang=js"
export * from "./Pallet.vue?vue&type=script&lang=js"
import style0 from "./Pallet.vue?vue&type=style&index=0&id=29433860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports